import React from "react";
import FHIRPatient from "../FHIRPatientRecord";
import FHIRDetails from "../FHIRDetails";
import Collapsible from "react-collapsible";
import Icon from "../Icon";
import Button from "../Button";
import ButtonList from "../ButtonList";
import AnchorButton from "../../components/AnchorButton";
import Popover from "../PopOver";
import { useState } from "react";

import styles from "./FHIRSummary.module.scss";

const FHIRSummary = ({
  id,
  patientInfo,
  priorAggregate,
  primaryRecords,
  linkageHistory = [],
  handleRecompute,
  canRecompute,
  isInvisible = false,
  handleRepartition,
  handleMultipleBirth,
  handleAggregateAuxDataRequest,
  isImdm,
  isPreviewMode = false
}) => {
  const [mockButtonTooltipHidden, setmockButtonTooltipHidden] = useState(true);
  return (
    <Collapsible
      transitionTime={90}
      trigger={
        <div className={styles.base}>
          <div className={styles.leftBanner}>
            <div className={styles.heading}>
              {isImdm ? "Enterprise ID (EID)" : "HCM ID"}
            </div>
            <div>{id}</div>
          </div>

          <FHIRPatient
            className={styles.patientInfo}
            patient={patientInfo}
            summary
          />
          {canRecompute && !isInvisible && (
            <ButtonList style={{ marginTop: "1.5rem" }}>
              {isImdm && (
                <AnchorButton
                  to={{ pathname: `mocksurvivorship/` }}
                  target="_blank"
                  rel="noopener noreferrer"
                  onMouseEnter={() => setmockButtonTooltipHidden(false)}
                  onMouseLeave={() => setmockButtonTooltipHidden(true)}
                >
                  <Button
                    primary
                    onClick={e => {
                      e.stopPropagation();
                    }}
                  >
                    Mock
                    {!mockButtonTooltipHidden && (
                      <Popover
                        caret
                        placement="bottom"
                        spacing={4}
                        valign="top"
                        visible={true}
                      >
                        Mock Survivorship
                      </Popover>
                    )}
                  </Button>
                </AnchorButton>
              )}

              <Button
                primary
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleMultipleBirth();
                }}
              >
                MultipleBirth
              </Button>

              <Button
                primary
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleRepartition();
                }}
              >
                Repartition
              </Button>
              <Button
                primary
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleRecompute();
                }}
              >
                Recompute
              </Button>
            </ButtonList>
          )}

          <div className={styles.buttonWrapper}>
            <Icon
              className={styles.expandArrow}
              type="arrow_down"
              size="2rem"
            ></Icon>
          </div>
        </div>
      }
    >
      <div className={styles.details}>
        <FHIRDetails
          patient={patientInfo}
          priorAggregate={priorAggregate}
          primaryRecords={primaryRecords}
          linkageHistory={linkageHistory}
          isAggregateInfo={true}
          isPreviewMode={isPreviewMode}
          onAggregateAuxDataUpdate={detailMap =>
            handleAggregateAuxDataRequest(detailMap)
          }
        />
      </div>
    </Collapsible>
  );
};

export default FHIRSummary;
